"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var Field_1 = require("@seaweb/coral/components/Field");
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
var TabsContext_1 = __importStar(require("./TabsContext"));
var TabsContainer = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === TabsContext_1.TabsOrientations.Vertical && styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n    "], ["\n      display: flex;\n    "])));
});
var Tabs = react_1.forwardRef(function Tabs(_a, ref) {
    var as = _a.as, idProp = _a.id, children = _a.children, indexProp = _a.index, _b = _a.initialIndex, initialIndex = _b === void 0 ? 0 : _b, onChange = _a.onChange, _c = _a.orientation, orientation = _c === void 0 ? TabsContext_1.TabsOrientations.Horizontal : _c, props = __rest(_a, ["as", "id", "children", "index", "initialIndex", "onChange", "orientation"]);
    var id = Field_1.useId(idProp);
    var _d = __read(react_1.useState(0), 2), cycle = _d[0], setCycle = _d[1];
    var _e = __read(useControlProp_1.default(indexProp, initialIndex, onChange), 2), activeIndex = _e[0], setActiveIndex = _e[1];
    var ctx = {
        id: id,
        activeIndex: activeIndex,
        setActiveIndex: setActiveIndex,
        cycle: cycle,
        setCycle: setCycle,
        orientation: orientation,
    };
    return (react_1.default.createElement(TabsContext_1.default.Provider, { value: ctx },
        react_1.default.createElement(TabsContainer, __assign({ as: as, ref: ref, orientation: orientation }, props), children)));
});
exports.default = react_1.memo(Tabs);
var templateObject_1, templateObject_2;
